import {
  GET_BRANDS,
  MODELS_RECEIVED,
  BRANDS_ERROR,
  BRANDS_RECEIVED,
  MODELS_ERROR,
  BRAND_SELECTED,
  VERSIONS_RECEIVED,
  VERSIONS_ERROR,
  MODEL_SELECTED,
  VERSION_SELECTED,
  CAR_ERROR,
  CAR_RECEIVED,
  GET_CAR_IMAGES,
  CAR_IMAGES_ERROR,
  CAR_IMAGES_RECEIVED,
  CAR_IMAGES_NEW,
  RESET,
} from './constants';

/**
 *
 * @returns {{type: *}}
 */
export const getBrands = () => ({
  type: GET_BRANDS,
});

/**
 *
 * @returns {{type: *}}
 */
export const getCarImages = () => ({
  type: GET_CAR_IMAGES,
});

/**
 *
 * @param brands
 * @returns {{brands: *, type: *}}
 */
export function brandsLoaded(brands) {
  return {
    type: BRANDS_RECEIVED,
    brands,
  };
}

/**
 *
 * @param images
 * @returns {{images: *, type: *}}
 */
export function carImagesLoaded(images) {
  return {
    type: CAR_IMAGES_RECEIVED,
    images,
  };
}

/**
 *
 * @param images
 * @returns {{image: *, type: *}}
 */
export function carImagesNew(images) {
  return {
    type: CAR_IMAGES_NEW,
    images,
  };
}

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export function brandsError(error) {
  return {
    type: BRANDS_ERROR,
    error,
  };
}

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export function carImagesError(error) {
  return {
    type: CAR_IMAGES_ERROR,
    error,
  };
}

/**
 *
 * @param selectedBrand
 * @returns {{selectedBrand: *, type: *}}
 */
export function selectBrand(selectedBrand) {
  return {
    type: BRAND_SELECTED,
    selectedBrand,
  };
}

/**
 *
 * @param models
 * @returns {{models: *, type: *}}
 */
export function modelsLoaded(models) {
  return {
    type: MODELS_RECEIVED,
    models,
  };
}

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export function modelsError(error) {
  return {
    type: MODELS_ERROR,
    error,
  };
}

/**
 *
 * @param selectedModel
 * @param selectedModelName
 * @param selectedModelYear
 * @returns {{selectedModelName: *, type: *, selectedModel: *}}
 */
export function selectModel(selectedModel, selectedModelName, selectedModelYear) {
  return {
    type: MODEL_SELECTED,
    selectedModel,
    selectedModelName,
    selectedModelYear
  };
}

/**
 *
 * @param versions
 * @returns {{versions: *, type: *}}
 */
export function versionsLoaded(versions) {
  return {
    type: VERSIONS_RECEIVED,
    versions,
  };
}

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export function versionsError(error) {
  return {
    type: VERSIONS_ERROR,
    error,
  };
}

/**
 *
 * @param selectedVersion
 * @returns {{selectedVersion: *, type: *}}
 */
export function selectVersion(selectedVersion) {
  return {
    type: VERSION_SELECTED,
    selectedVersion,
  };
}

/**
 *
 * @param car
 * @returns {{car: *, type: *}}
 */
export function carLoaded(car) {
  return {
    type: CAR_RECEIVED,
    car,
  };
}

/**
 *
 * @param error
 * @returns {{type: *, error: *}}
 */
export function carError(error) {
  return {
    type: CAR_ERROR,
    error,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export function resetStore() {
  return {
    type: RESET,
  };
}
